import MyButtonSpinner from 'components/common/my-components/MyButtonSpinner';
import { Field, Form as FormFormik, Formik } from 'formik';
import { useState } from 'react';
import { Button, Card, Col, Form, Row, Alert } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import { createRealEstate } from 'redux/realEstateSlice';
import * as yup from 'yup';

const validationSchema = yup.object().shape({
  name: yup.string().required('Campo requerido'),
  email: yup.string().email('Email inválido').required('Campo requerido'),
  phoneNumber: yup.number().required('Campo requerido'),
  address: yup.string().required('Campo requerido')
});

const FormNuevaInmobiliaria = () => {
  const dispatch = useDispatch();
  const userLogged = useSelector(state => state.login.currentUser);

  const [loadingButton, setLoadingButton] = useState(false);

  const handleSubmit = async values => {
    setLoadingButton(true);

    if (userLogged?.id && !loadingButton) {
      await dispatch(createRealEstate({ ...values, userId: userLogged.id }));
    }

    setLoadingButton(false);
  };

  return (
    <Card className="bg-white">
      <Card.Header>
        <Card.Title className="mb-0">Creá tu Inmobiliaria</Card.Title>
        <Alert variant="info" className="mt-3">
          No tenés una inmobiliaria asociada a tu cuenta. Antes de continuar,
          por favor completá los siguientes datos para crear una.
        </Alert>
      </Card.Header>

      <Card.Body>
        <Formik
          initialValues={{
            name: '',
            email: '',
            phoneNumber: '',
            address: ''
          }}
          validationSchema={validationSchema}
          onSubmit={handleSubmit}
        >
          {({ errors, touched }) => (
            <FormFormik>
              <Row className="g-3">
                <Col xs={12} md={6}>
                  <Form.Group>
                    <Form.Label>Nombre</Form.Label>
                    <Form.Control
                      as={Field}
                      name="name"
                      type="text"
                      placeholder="Ingresa un nombre"
                      isInvalid={errors.name && touched.name}
                    />
                    {errors.name && touched.name && (
                      <p className="text-danger small m-0">{errors.name}</p>
                    )}
                  </Form.Group>
                </Col>

                <Col xs={12} md={6}>
                  <Form.Group>
                    <Form.Label>Email</Form.Label>
                    <Form.Control
                      as={Field}
                      name="email"
                      type="text"
                      placeholder="Ingresa un email"
                      isInvalid={errors.email && touched.email}
                    />
                    {errors.email && touched.email && (
                      <p className="text-danger small m-0">{errors.email}</p>
                    )}
                  </Form.Group>
                </Col>

                <Col xs={12} md={6}>
                  <Form.Group>
                    <Form.Label>Teléfono</Form.Label>
                    <Form.Control
                      as={Field}
                      name="phoneNumber"
                      type="number"
                      placeholder="Ingresa un teléfono"
                      isInvalid={errors.phoneNumber && touched.phoneNumber}
                    />
                    {errors.phoneNumber && touched.phoneNumber && (
                      <p className="text-danger small m-0">
                        {errors.phoneNumber}
                      </p>
                    )}
                  </Form.Group>
                </Col>

                <Col xs={12} md={6}>
                  <Form.Group>
                    <Form.Label>Dirección</Form.Label>
                    <Form.Control
                      as={Field}
                      name="address"
                      type="text"
                      placeholder="Ingresa una dirección"
                      isInvalid={errors.address && touched.address}
                    />
                    {errors.address && touched.address && (
                      <p className="text-danger small m-0">{errors.address}</p>
                    )}
                  </Form.Group>
                </Col>

                <Col xs={12}>
                  {!loadingButton ? (
                    <Button
                      variant="primary"
                      type="submit"
                      className="w-100"
                      disabled={
                        !!errors.nombre ||
                        !!errors.apellido ||
                        !!errors.email ||
                        !!errors.dni ||
                        !!errors.matricula ||
                        loadingButton
                      }
                    >
                      Registrar Inmobiliaria
                    </Button>
                  ) : (
                    <MyButtonSpinner className="w-100" />
                  )}
                </Col>
              </Row>
            </FormFormik>
          )}
        </Formik>
      </Card.Body>
    </Card>
  );
};

export default FormNuevaInmobiliaria;
